import React from "react";

import { SubHeaderTabs } from "src/layout/SubHeader";
import { DashboardPageParams, getUrlToSettingsPage } from "src/router/urls";
import { SettingsSubpages } from "src/settings/SettingsSubpages";
import { SdkBundlesToolbar } from "src/settings/sdks/components/SdkBundlesToolbar";
import { SdkSubHeaderTab } from "src/settings/sdks/components/SdkSubHeaderTab";
import { useParamsDecode } from "src/utils/useParamsDecode";

type SdkSettingsSubHeaderProps = {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAddClick: () => void;
  addTooltip: string;
  searchDataLoc: string;
  addDataLoc: string;
};

export const SdkSettingsSubHeader: React.FC<SdkSettingsSubHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onAddClick,
  addTooltip,
  searchDataLoc,
  addDataLoc,
}) => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <div
      className="flex h-12 shrink-0 items-center justify-between overflow-hidden border-gray-200 border-b border-l bg-white pl-3.5"
      data-loc="sdk-settings-subheader"
    >
      <SubHeaderTabs dataLoc="sdk-settings-tabs">
        <SdkSubHeaderTab
          dataLoc="sdk-bundles-tab"
          end
          to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.SdkBundles)}
        >
          SDK Bundles
        </SdkSubHeaderTab>
        <SdkSubHeaderTab
          dataLoc="sdk-scripts-tab"
          end
          to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.SdkScripts)}
        >
          SDK Scripts
        </SdkSubHeaderTab>
      </SubHeaderTabs>
      <div className="flex h-full items-center self-end overflow-clip">
        <SdkBundlesToolbar
          addDataLoc={addDataLoc}
          addTooltip={addTooltip}
          searchDataLoc={searchDataLoc}
          searchQuery={searchQuery}
          onAddClick={onAddClick}
          onSearchChange={onSearchChange}
        />
      </div>
    </div>
  );
};
